import {initTemplateSubstitutions} from './templateSubstitutions';

export const companySubstitutions = initTemplateSubstitutions({
  'my.company.name': {name: 'Company Name', field: 'name'},
  'my.company.phone': {name: 'Phone', field: 'phone'},
  'my.company.website': {name: 'Website', field: 'website'},
  'my.company.email': {name: 'Email', field: 'email'},
  'my.company.currency': {name: 'Currency Symbol', field: 'currencySymbol'},
}, 'company');
